'use client';

import React, { useEffect, useRef } from 'react';
import { featureTimeslotsConfig } from '@/shared/config/tests/e2e/features/booking';
import { useDragScroll } from '@/shared/hooks/dom/scroll/useDragScroll';
import { useElementScroll } from '@/shared/hooks/dom/scroll/useElementScroll';
import { useScrollVisibility } from '@/shared/hooks/dom/scroll/useScrollVisibility';
import { classNames } from '@/shared/lib/classnames/classnames';
import { ScrollShadow } from '@/shared/ui/scroll-shadow';
import { TimeSlotButton } from './TimeSlotButton';
import type { TimeSlotsListProps } from '../../model/types';
export const TimeSlotsList: React.FC<TimeSlotsListProps> = ({
  selectedDay,
  scrollToSelected,
  selectedSlot,
  handleSlotClick,
  mini
}) => {
  const slotsContainerRef = useRef<HTMLDivElement>(null);
  const {
    showLeftControl,
    showRightControl
  } = useScrollVisibility(slotsContainerRef);
  const {
    scrollToElement
  } = useElementScroll(slotsContainerRef);
  const {
    dragHandlers
  } = useDragScroll(slotsContainerRef, {
    dragSpeedMultiplier: 1.5,
    dragThreshold: 5
  });
  const clickSlot = (slot: string, index: number) => {
    handleSlotClick(slot);
    if (typeof 'window' !== 'undefined' && window.innerWidth <= 768 || mini) {
      scrollToElement(index);
    }
  };
  useEffect(() => {
    if (selectedDay) {
      let scrolledIndex = 0;
      if (scrollToSelected && selectedDay.timeslots) {
        scrolledIndex = selectedDay.timeslots.findIndex(item => item === selectedSlot);
      }
      scrollToElement(scrolledIndex);
    }
  }, [selectedDay]);
  if (!selectedDay?.timeslots || selectedDay.timeslots.length === 0) return null;
  return <div className="relative" data-sentry-component="TimeSlotsList" data-sentry-source-file="TimeSlotsList.tsx">
      <div ref={slotsContainerRef} {...dragHandlers} className={classNames('mt-4 flex flex-nowrap gap-2 overflow-x-auto scroll-width-none', {
      'md:grid md:grid-cols-6': !mini
    })} data-testid={featureTimeslotsConfig.ids.slotsContainer}>
        {selectedDay.timeslots.map((slot, index) => <TimeSlotButton key={`slot-${slot}`} slot={slot} isSelected={slot === selectedSlot} onClick={() => clickSlot(slot, index)} mini={mini} />)}
      </div>

      <ScrollShadow showLeftShadow={showLeftControl} showRightShadow={showRightControl} data-sentry-element="ScrollShadow" data-sentry-source-file="TimeSlotsList.tsx" />
    </div>;
};